(() => {
  document.addEventListener("DOMContentLoaded", () => {
    // Inicialización de componentes
    initLoader();
    initContentOverMediaSpacing();
    setupGalleryClickHandler();
    setupLookCellHoverOrClick();
  });

  // 🔄 Manejo del loader inicial con sessionStorage
  function initLoader() {
    /*const loader = document.getElementById("loader");
    if (!loader) return;

    const logo = loader.querySelector("img");

    const hideLoader = () => {
      loader.style.transition = "opacity 0.5s ease-out";
      loader.style.opacity = "0";
      setTimeout(() => loader.remove(), 500);
    };

    const firstVisit = !sessionStorage.getItem("hasVisited");

    if (firstVisit) {
      logo?.classList.add("logo-out");

      // Timeout fijo para que desaparezca rápido aunque los vídeos no carguen
      setTimeout(() => {
        hideLoader();
        sessionStorage.setItem("hasVisited", "true");
      }, 500);

      // Timeout de seguridad adicional (opcional)
      setTimeout(() => {
        if (loader.parentNode) {
          loader.remove();
        }
      }, 5000); // 5s máximo por si algún dispositivo falla
    } else {
      loader.remove();
    }*/
  }
  

  // 📐 Ajuste dinámico del gap visual basado en altura de .scrolling-fixed
  function initContentOverMediaSpacing() {
    const scrollingFixed = document.querySelector(".scrolling-fixed");
    const contentOverMedia = document.querySelector(
      ".shopify-section--slideshow .slideshow .content-over-media"
    );

    if (!scrollingFixed || !contentOverMedia) return;

    const updateGap = () => {
      requestAnimationFrame(() => {
        const height = scrollingFixed.offsetHeight;
        contentOverMedia.style.setProperty(
          "--content-over-media-row-gap",
          `${height}px`
        );
      });
    };

    updateGap(); // Inicial
    new ResizeObserver(updateGap).observe(scrollingFixed);
  }

  // 🖱️ Detectar clics sin drag en imágenes del carrusel
  function setupGalleryClickHandler() {
    const dragThreshold = 5;
    let startX = 0;
    let startY = 0;

    document.querySelectorAll(".product-gallery__media").forEach((el) => {
      el.addEventListener("mousedown", (e) => {
        startX = e.clientX;
        startY = e.clientY;
      });

      el.addEventListener("mouseup", (e) => {
        const deltaX = Math.abs(e.clientX - startX);
        const deltaY = Math.abs(e.clientY - startY);
        const isClick = deltaX < dragThreshold && deltaY < dragThreshold;

        if (isClick) {
          el.dispatchEvent(new CustomEvent("lightbox:open", { bubbles: true }));
        }
      });
    });
  }

  // 🖱️ Configuración del comportamiento de hover o click para "look cells"
  function setupLookCellHoverOrClick() {
    const lookCells = document.querySelectorAll(".look-cell");
    const isHoverCapable = window.matchMedia("(hover: hover)").matches;

    lookCells.forEach((lookCell) => {
      const productsLooks = lookCell.querySelector(".products-looks");
      if (!productsLooks) return;

      const showProductsLooks = () => productsLooks.classList.add("visible");
      const hideProductsLooks = () => productsLooks.classList.remove("visible");

      if (isHoverCapable) {
        // Hover en PC
        lookCell.addEventListener("mouseenter", showProductsLooks);
        lookCell.addEventListener("mouseleave", hideProductsLooks);
      } else {
        // Click en táctil
        lookCell.addEventListener("click", (event) => {
          const isVisible = productsLooks.classList.contains("visible");

          if (!isVisible) {
            event.preventDefault(); // Evitamos que se active el link
            showProductsLooks();
          }
        });

        // Opcional: cerrar al hacer clic fuera
        document.addEventListener("click", (e) => {
          if (!lookCell.contains(e.target)) {
            hideProductsLooks();
          }
        });
      }
    });
  }
})();

document.addEventListener("DOMContentLoaded", () => {
  const menuList = document.querySelector(".collection-toolbar__menu-list");
  const header = document.querySelector("x-header");
  const toolbar = document.querySelector(".collection-toolbar");

  const activateHover = () => {
    header?.classList.add("hover-simulated");
    toolbar?.classList.add("hover-simulated");
  };

  const deactivateHover = (e) => {
    // Si estamos en modo scroll, no desactivar por mouseleave
    if (isScrolled) return;
    const related = e.relatedTarget;
    if (!menuList?.contains(related) && !header?.contains(related)) {
      header?.classList.remove("hover-simulated");
      toolbar?.classList.remove("hover-simulated");
    }
  };

  // Hover en menú (solo si existe)
  if (menuList) {
    menuList.addEventListener("mouseenter", activateHover);
    menuList.addEventListener("mouseleave", deactivateHover);
  }

  // Hover en header
  header?.addEventListener("mouseenter", activateHover);
  header?.addEventListener("mouseleave", deactivateHover);

  // Scroll en móvil
  let isScrolled = false;
  const SCROLL_THRESHOLD = 25;

  window.addEventListener("scroll", () => {
    if (window.matchMedia("(hover: none)").matches) {
      if (window.scrollY >= SCROLL_THRESHOLD && !isScrolled) {
        isScrolled = true;
        activateHover();
      } else if (window.scrollY < SCROLL_THRESHOLD && isScrolled) {
        isScrolled = false;
        header?.classList.remove("hover-simulated");
        toolbar?.classList.remove("hover-simulated");
      }
    }
  }, { passive: true });
});



// 📌 Barra de compra sticky en móvil (color + tallas + botón + texto de envío).
// Comportamiento: sticky al abrir la página -> deja de serlo cuando el formulario real entra
// en pantalla -> vuelve a serlo cuando se ha pasado -> se oculta al llegar al footer.
(() => {
  const mobileQuery = window.matchMedia("(max-width: 999px)");
  const observedGroups = new WeakSet();
  let frame = 0;

  const resizeObserver =
    "ResizeObserver" in window ? new ResizeObserver(() => schedule()) : null;

  function getGroups() {
    return [...document.querySelectorAll(".form-group.block-form")].filter(
      (group) => !group.closest(".pfm-dialog, .quick-buy-modal, template")
    );
  }

  function update() {
    frame = 0;

    const viewportHeight = window.innerHeight;
    const tickerHeight =
      parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue("--scrolling-ticker-h")
      ) || 0;
    const footer = document.querySelector(".footer__inner") || document.querySelector("footer");

    getGroups().forEach((group) => {
      const slot = group.closest(".block-form-slot");
      if (!slot) return;

      if (!mobileQuery.matches) {
        group.classList.remove("is-in-flow", "is-after-form", "hide-on-footer");
        slot.style.minHeight = "";
        return;
      }

      if (resizeObserver && !observedGroups.has(group)) {
        observedGroups.add(group);
        resizeObserver.observe(group);
      }

      // Reservamos en el flujo el hueco del formulario para poder medir su posición natural
      const height = group.offsetHeight;
      // Solo crece: en sticky el botón de compra va oculto y la barra es más baja; si el hueco encogiera
      // al entrar en el flujo, el formulario oscilaría entre sticky y en flujo
      if (height > (parseFloat(slot.style.minHeight) || 0)) slot.style.minHeight = `${height}px`;

      // Altura de la barra cuando va fija (en el flujo es más alta: salen PayPal y más opciones de pago, debajo)
      if (!group.classList.contains("is-in-flow")) group._stickyHeight = height;
      const stickyTop = viewportHeight - tickerHeight - (group._stickyHeight || height);

      // Se incorpora a la página cuando la parte de arriba de su hueco llega a donde está la barra fija: color,
      // tallas y botón quedan en el mismo sitio, sin salto, y lo que solo sale en el flujo aparece por debajo.
      // (Antes esperaba a que llegara la parte de abajo del hueco: se veía un espacio en blanco y luego saltaba.)
      const rect = slot.getBoundingClientRect();
      const isBefore = rect.top > stickyTop; // aún no ha llegado
      const isAfter = rect.bottom < 0; // ya se ha pasado
      const inFlow = !isBefore && !isAfter;

      group.classList.toggle("is-in-flow", inFlow);
      group.classList.toggle("is-after-form", isAfter);

      const footerVisible = footer && footer.getBoundingClientRect().top <= viewportHeight;
      group.classList.toggle("hide-on-footer", !inFlow && Boolean(footerVisible));
    });
  }

  function schedule() {
    if (!frame) frame = requestAnimationFrame(update);
  }

  function init() {
    window.addEventListener("scroll", schedule, { passive: true });
    window.addEventListener("resize", schedule);
    window.addEventListener("pageshow", schedule);
    window.addEventListener("load", schedule);
    mobileQuery.addEventListener?.("change", schedule);

    // Al cambiar de variante el bloque de producto se vuelve a renderizar (se sustituye el DOM)
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });

    // Cambios de layout (imágenes, widgets de terceros como Big Blue...) desplazan el formulario
    resizeObserver?.observe(document.body);

    schedule();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();


// 📏 Guía de tallas (snippets/size-table.liquid): cambio CM/IN y resaltado de fila y columna bajo el cursor
if (!customElements.get("size-table")) {
  customElements.define("size-table", class extends HTMLElement {
    connectedCallback() {
      if (this.hasListeners) return;
      this.hasListeners = true;

      this.addEventListener("click", (event) => {
        const button = event.target.closest(".size-table__unit");
        if (!button) return;

        this.dataset.unit = button.dataset.unit;
        this.querySelectorAll(".size-table__unit").forEach((unit) => {
          unit.setAttribute("aria-pressed", String(unit === button));
        });
      });

      this.addEventListener("pointerover", (event) => {
        const cell = event.target.closest(".size-table__table :is(th, td)");
        if (cell) this.highlight(cell);
      });

      this.addEventListener("pointerleave", () => this.highlight(null));
    }

    highlight(cell) {
      this.querySelectorAll(".is-highlighted").forEach((el) => el.classList.remove("is-highlighted"));
      if (!cell) return;

      cell.closest("tbody tr")?.classList.add("is-highlighted");

      const column = cell.dataset.col;
      if (column && column !== "0") {
        this.querySelectorAll(`.size-table__table [data-col="${column}"]`).forEach((el) => el.classList.add("is-highlighted"));
      }
    }
  });
}

document.addEventListener('click', async (event) => {
  const button = event.target.closest('.product-card__size[data-variant-id]');
  if (!button || button.disabled) return;

  const variantId = button.getAttribute('data-variant-id');

  button.setAttribute('aria-busy', 'true');
  document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

  let sectionsToBundle = [];
  document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));

  const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ id: variantId, quantity: 1, sections: sectionsToBundle.join(',') })
  });

  button.removeAttribute('aria-busy');
  document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));

  if (response.ok) {
    const responseJson = await response.json();
    const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
    cartContent['sections'] = responseJson['sections'];

    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart: cartContent }
    }));
  }
});
// Swipe horizontal en mobile para mostrar imagen secundaria de product-card
(function () {
  if (window.matchMedia('(pointer: fine)').matches) return;

  var startX = 0, startY = 0;
  var activeFigure = null;
  var didSwipe = false;

  document.addEventListener('touchstart', function (e) {
    var media = e.target.closest('.product-card__media');
    if (!media || !media.querySelector('.product-card__image--secondary') || e.target.closest('scroll-carousel')) {
      activeFigure = null;
      return;
    }
    var t = e.touches[0];
    startX = t.clientX;
    startY = t.clientY;
    activeFigure = media.closest('.product-card__figure');
    didSwipe = false;
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    if (!activeFigure) return;
    var t = e.touches[0];
    var dx = t.clientX - startX;
    var dy = t.clientY - startY;
    if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 8) {
      e.preventDefault();
      didSwipe = true;
    }
  }, { passive: false });

  document.addEventListener('touchend', function (e) {
    if (!activeFigure) return;
    var dx = Math.abs(e.changedTouches[0].clientX - startX);
    if (didSwipe && dx > 20) {
      activeFigure.classList.toggle('product-card__figure--swiped');
      var block = function (ev) {
        ev.preventDefault();
        document.removeEventListener('click', block, true);
      };
      document.addEventListener('click', block, true);
    }
    activeFigure = null;
    didSwipe = false;
  }, { passive: true });
})();

// 🔍 Cursor de zoom de la galería de producto: cuadrado que desenfoca la foto que tiene debajo, con una cruz
// que invierte el color (mix-blend-mode: difference). Un cursor CSS no puede aplicar blur ni fundirse con la foto,
// así que se oculta y dos elementos siguen al ratón: el desenfoque y, encima, la cruz (solo con ratón).
(() => {
  if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;

  const ZOOM_MEDIA_SELECTOR = ".product-gallery[allow-zoom] .product-gallery__media";
  let cursorParts = null;

  const createCursorPart = (className) => {
    const part = document.createElement("div");
    part.className = className;
    part.setAttribute("aria-hidden", "true");
    document.body.append(part);
    return part;
  };

  const setVisible = (visible) => cursorParts?.forEach((part) => part.classList.toggle("is-visible", visible));

  document.addEventListener("pointermove", (event) => {
    const overZoomMedia = event.target.closest?.(ZOOM_MEDIA_SELECTOR);

    if (!cursorParts) {
      if (!overZoomMedia) return;
      cursorParts = [createCursorPart("zoom-cursor"), createCursorPart("zoom-cursor-cross")];
    }

    setVisible(Boolean(overZoomMedia));

    if (overZoomMedia) {
      const position = `translate(${event.clientX}px, ${event.clientY}px)`;
      cursorParts.forEach((part) => (part.style.transform = position));
    }
  }, { passive: true });

  document.documentElement.addEventListener("mouseleave", () => setVisible(false));
})();

// 👕 Sin talla preseleccionada al entrar en un producto (salvo que la URL traiga ?variant=).
// Se desmarca la talla y, hasta que se elija una, el botón de compra no añade nada: lleva al selector y lo resalta.
(() => {
  const PICKER_SELECTOR = '.shopify-section--main-product variant-picker[context="main_product"]';

  function clearSelection() {
    if (new URLSearchParams(location.search).has("variant")) return;

    document.querySelectorAll(PICKER_SELECTOR).forEach((picker) => {
      const form = document.getElementById(picker.getAttribute("form-id"));
      if (!form) return;

      picker.querySelectorAll('input[type="radio"]:checked').forEach((input) => (input.checked = false));
      form.dataset.noSize = "true";

      picker.addEventListener("change", () => {
        delete form.dataset.noSize;
        document.querySelectorAll(PICKER_SELECTOR).forEach((p) => p.classList.remove("variant-picker--required"));
      }, { once: true });
    });
  }

  // Se captura antes que el formulario del tema para que no añada la talla por defecto
  document.addEventListener("submit", (event) => {
    const form = event.target;
    if (!form.dataset?.noSize) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    // form.id devolvería el <input name="id"> del formulario, por eso se lee el atributo
    const picker = document.querySelector(`${PICKER_SELECTOR}[form-id="${form.getAttribute("id")}"]`);
    if (!picker) return;

    picker.classList.remove("variant-picker--required");
    void picker.offsetWidth; // reinicia la animación
    picker.classList.add("variant-picker--required");
    picker.scrollIntoView({ behavior: "smooth", block: "center" });
  }, true);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", clearSelection);
  } else {
    clearSelection();
  }
})();


// 🖥️ Ficha de producto en escritorio: la columna derecha empieza a la misma altura que el texto de la izquierda
// (que va centrado en vertical). Se guarda en --info-offset sobre la sección para sobrevivir al re-render de variante.
(() => {
  const desktopQuery = window.matchMedia("(min-width: 1000px)");

  function alignInfo() {
    document.querySelectorAll(".shopify-section--main-product").forEach((section) => {
      const leftList = section.querySelector(".product > .product-info-extra .product-info__block-list");
      const rightList = section.querySelector(".product > .product-info .product-info__block-list");
      if (!leftList || !rightList) return;

      if (!desktopQuery.matches) {
        section.style.removeProperty("--info-offset");
        return;
      }

      // Con la página desplazada las columnas sticky ya no están en su sitio y la medida saldría mal
      if (window.scrollY > 0) return;

      section.style.removeProperty("--info-offset");
      // Dos pasadas: al desplazar la derecha la columna izquierda puede moverse unos píxeles (cambia el desbordamiento)
      let offset = 0;
      for (let pass = 0; pass < 2; pass++) {
        offset += leftList.getBoundingClientRect().top - rightList.getBoundingClientRect().top;
        section.style.setProperty("--info-offset", `${Math.max(0, offset)}px`);
      }

      // En pantallas bajas el desplazamiento sacaba la columna por debajo de la ficha y tapaba la sección
      // siguiente: se limita para que el final de la columna no pase del final de la ficha.
      const product = section.querySelector(".product");
      const overflow = rightList.getBoundingClientRect().bottom - product.getBoundingClientRect().bottom;
      if (overflow > 0) {
        offset = Math.max(0, offset) - overflow;
        section.style.setProperty("--info-offset", `${Math.max(0, offset)}px`);
      }
    });
  }

  window.addEventListener("resize", alignInfo);
  window.addEventListener("load", alignInfo);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", alignInfo);
  } else {
    alignInfo();
  }
})();

// 🖥️ Completa tu look (ajuste "Mostrar Completa tu look al hacer scroll"): oculto en escritorio hasta que la
// página se desplaza un poco (scroll sobre los laterales, o al terminar el scroll de las fotos). Ver all-products-collection.css
(() => {
  const reveal = () => {
    if (window.scrollY <= 10) return;
    document.documentElement.classList.add("look-revealed");
    window.removeEventListener("scroll", reveal);
  };

  window.addEventListener("scroll", reveal, { passive: true });
  reveal();
})();

// 🔁 Completa tu look: carrusel infinito con la tarjeta del centro algo más grande.
// Las tarjetas se duplican antes y después del original; al acercarse a un extremo se salta un bloque entero sin
// que se note. Los clones no llevan el modal de compra rápida (su botón abre el del original por aria-controls).
(() => {
  const CENTER_SCALE = 0.15; // cuánto crece la tarjeta centrada (0.15 = 15 %)

  function setupCarousel(track) {
    if (track.dataset.infinite) return;

    const originals = [...track.querySelectorAll(":scope > .cl2__card")];
    if (originals.length < 2) return;
    track.dataset.infinite = "true";

    const makeClones = () =>
      originals.map((card) => {
        const clone = card.cloneNode(true);
        clone.setAttribute("aria-hidden", "true");
        clone.querySelectorAll("quick-buy-modal").forEach((modal) => modal.remove());
        clone.querySelectorAll("a, button").forEach((el) => el.setAttribute("tabindex", "-1"));
        return clone;
      });

    track.prepend(...makeClones());
    track.append(...makeClones());

    const firstClone = track.firstElementChild;
    const setWidth = () => originals[0].offsetLeft - firstClone.offsetLeft;
    let frame = 0;

    const update = () => {
      frame = 0;
      const width = setWidth();
      if (!width) return;

      // Mantener el scroll dentro del bloque central
      if (track.scrollLeft < width * 0.5) track.scrollLeft += width;
      else if (track.scrollLeft > width * 1.5) track.scrollLeft -= width;

      const center = track.scrollLeft + track.clientWidth / 2;
      [...track.children].forEach((card) => {
        const cardCenter = card.offsetLeft + card.offsetWidth / 2;
        const closeness = Math.max(0, 1 - Math.abs(cardCenter - center) / card.offsetWidth);
        card.style.transform = `scale(${1 + CENTER_SCALE * closeness})`;
      });
    };

    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };

    // Empezar con el primer producto original centrado
    track.scrollLeft = originals[0].offsetLeft - (track.clientWidth - originals[0].offsetWidth) / 2;
    track.addEventListener("scroll", schedule, { passive: true });
    window.addEventListener("resize", schedule);
    schedule();
  }

  const init = () => document.querySelectorAll(".cl2__cards").forEach(setupCarousel);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // La ficha se vuelve a pintar al cambiar de variante
  new MutationObserver(init).observe(document.documentElement, { childList: true, subtree: true });
})();


// 🖼️ Miniaturas de la galería en escritorio (ajuste de sección "Miniaturas en la galería", estilo Scuffers):
// columna de miniaturas a la izquierda de las fotos; la foto que se está viendo va en color y el resto más pálidas.
// Al pulsar una miniatura la galería se desplaza hasta esa foto. Estilos en all-products-collection.css
(() => {
  const desktopQuery = window.matchMedia("(min-width: 1000px)");

  function setupThumbs(product) {
    const gallery = product.querySelector(":scope > product-gallery.pc_hidden");
    if (!gallery || gallery.dataset.thumbs) return;

    const medias = [...gallery.querySelectorAll(".product-gallery__media")].filter((media) => media.querySelector("img"));
    if (medias.length < 2) return;
    gallery.dataset.thumbs = "true";

    const list = document.createElement("div");
    list.className = "gallery-thumbs";

    const thumbs = medias.map((media, index) => {
      const source = media.querySelector("img");
      const button = document.createElement("button");
      button.type = "button";
      button.className = "gallery-thumbs__item";
      button.setAttribute("aria-label", `${index + 1} / ${medias.length}`);

      const image = document.createElement("img");
      image.src = source.currentSrc || source.src;
      image.alt = "";
      image.loading = "lazy";
      button.append(image);

      button.addEventListener("click", () => {
        const top = media.getBoundingClientRect().top - gallery.getBoundingClientRect().top + gallery.scrollTop;
        gallery.scrollTo({ top, behavior: "smooth" });
      });

      list.append(button);
      return button;
    });

    product.append(list);

    // Activa la miniatura de la foto más cercana al centro de la galería
    let frame = 0;
    const update = () => {
      frame = 0;
      const galleryRect = gallery.getBoundingClientRect();
      const center = galleryRect.top + galleryRect.height / 2;
      let active = 0;
      let best = Infinity;

      medias.forEach((media, index) => {
        const rect = media.getBoundingClientRect();
        const distance = Math.abs(rect.top + rect.height / 2 - center);
        if (distance < best) {
          best = distance;
          active = index;
        }
      });

      thumbs.forEach((thumb, index) => thumb.classList.toggle("is-active", index === active));
    };

    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };

    gallery.addEventListener("scroll", schedule, { passive: true });
    window.addEventListener("resize", schedule);
    update();
  }

  const init = () => {
    if (!desktopQuery.matches) return;
    document.querySelectorAll(".shopify-section--main-product .product--gallery-thumbs").forEach(setupThumbs);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  desktopQuery.addEventListener?.("change", init);
  // La ficha se vuelve a pintar al cambiar de variante
  new MutationObserver(init).observe(document.documentElement, { childList: true, subtree: true });
})();
